// Chat is available 09:00 - 23:59 Madrid time.
export function isChatHour(now = Date.now()) {
    const hour = Number(new Date(now).toLocaleString('en-US', {
        timeZone: 'Europe/Madrid',
        hour: 'numeric',
        hourCycle: 'h23',
    }))
    return hour >= 7 && hour <= 23
}